import React, { useEffect, useState } from 'react';
import { App, DatePicker, Form, Input } from 'antd';
import { createMySortie, listMySorties } from '../../api/sorties';
import { getApiErrorMessage } from '../../utils/apiError';

const WarnIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

export default function NewSortie() {
  const { message, notification } = App.useApp();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [hasActive, setHasActive] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const rows = await listMySorties();
        setHasActive((rows || []).some(r => r.date_sortie && !r.date_retour_effective));
      } catch (e) {
        notification.error({ message: getApiErrorMessage(e, 'Impossible de vérifier vos sorties actives.'), placement: 'topRight' });
      }
    })();
  }, [notification]);

  const onSubmit = async () => {
    try {
      const v = await form.validateFields();
      if (hasActive) { notification.error({ message: 'Vous avez une sortie active. Finalisez le retour avant une nouvelle demande.', placement: 'topRight' }); return; }
      if (v.date_sortie_prevue && v.date_retour_prevue && v.date_retour_prevue.isBefore(v.date_sortie_prevue)) { notification.error({ message: 'La date de retour doit être postérieure à la date de sortie.', placement: 'topRight' }); return; }
      setLoading(true);
      await createMySortie({ destination: v.destination || null, motif: v.motif || null, date_sortie_prevue: v.date_sortie_prevue ? v.date_sortie_prevue.toISOString() : null, date_retour_prevue: v.date_retour_prevue ? v.date_retour_prevue.toISOString() : null });
      message.success('Demande de sortie envoyée (en attente de validation).');
      form.resetFields();
    } catch (e) {
      if (e?.response || e?.message) notification.error({ message: getApiErrorMessage(e, 'Envoi de la demande échoué.'), placement: 'topRight' });
    } finally { setLoading(false); }
  };

  return (
    <div className="page">
      <div className="card" style={{ maxWidth: 560 }}>
        <div className="info-bar" style={{ borderBottom: '0.5px solid rgba(0,0,0,0.08)', padding: '12px 16px' }}>
          <span style={{ fontWeight: 600, fontSize: 13 }}>Nouvelle demande de sortie</span>
        </div>

        {hasActive && (
          <div className="info-bar warn-bar">
            <WarnIcon />
            <div>
              <div className="info-bar-title">Sortie active en cours</div>
              <div className="info-bar-desc">Veuillez d'abord effectuer votre retour (IN) avant de soumettre une nouvelle demande.</div>
            </div>
          </div>
        )}

        <div className="card-inner">
          <Form form={form} layout="vertical">
            <Form.Item name="destination" label="Destination" style={{ marginBottom: 12 }}>
              <Input placeholder="Ex: Abidjan" />
            </Form.Item>
            <Form.Item name="motif" label="Motif" style={{ marginBottom: 12 }}>
              <Input.TextArea rows={3} />
            </Form.Item>
            <div className="two-col" style={{ marginBottom: 12 }}>
              <Form.Item name="date_sortie_prevue" label="Date et heure de sortie" rules={[{ required: true }]} style={{ marginBottom: 0 }}>
                <DatePicker showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" style={{ width: '100%' }} />
              </Form.Item>
              <Form.Item name="date_retour_prevue" label="Date et heure de retour prévue" rules={[{ required: true }]} style={{ marginBottom: 0 }}>
                <DatePicker showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" style={{ width: '100%' }} />
              </Form.Item>
            </div>
            <button className="btn-primary btn-tall" onClick={onSubmit} disabled={hasActive || loading}>
              {loading ? 'Envoi en cours…' : 'Envoyer la demande'}
            </button>
          </Form>
        </div>
      </div>
    </div>
  );
}
